module.exports = __webpack_public_path__ + "static/integration/img/ally-icon-indicator-high-learnUltra.e0e3bd3392a2e45e8ca17c81e764e07f.svg";